/**
 * A confetti burst centred on `element`. canvas-confetti is loaded on first
 * use, so it costs nothing until something is celebrated. Bursts out in every
 * direction, slow and light enough to stay a burst around the element rather
 * than a fountain. Skipped entirely with reduced motion. `options` override
 * the burst's defaults (e.g. a smaller one).
 */
export async function burstFrom(element, colours, options = {}) {
  const { default: confetti } = await import("canvas-confetti");
  const rect = element.getBoundingClientRect();
  const origin = {
    x: (rect.left + rect.width / 2) / window.innerWidth,
    y: (rect.top + rect.height / 2) / window.innerHeight,
  };
  confetti({
    origin,
    spread: 360,
    startVelocity: 18,
    gravity: 0.6,
    decay: 0.9,
    particleCount: 70,
    ticks: 120,
    scalar: 0.8,
    colors: colours,
    // Above toasts and dialogs
    zIndex: 10000,
    disableForReducedMotion: true,
    ...options,
  });
}
